import type { WatchlistItem } from "../types";
import { money } from "./format";

export function dailyPriceChange(item: WatchlistItem): number | null {
  if (item.latest_price == null || item.prev_close == null) return null;
  return item.latest_price - item.prev_close;
}

export function signedMoney(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return "—";
  if (value === 0) return money(0);
  return `${value > 0 ? "+" : "-"}${money(Math.abs(value))}`;
}

export function quoteDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "—";
  return new Intl.DateTimeFormat(undefined, {
    month: "short",
    day: "numeric",
    timeZone: "America/New_York",
  }).format(date);
}

export function quoteTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "—";
  return new Intl.DateTimeFormat(undefined, {
    hour: "numeric",
    minute: "2-digit",
  }).format(date);
}

export function quoteSessionLine(item: WatchlistItem): string | null {
  if (!item.price_fetched_at) return null;
  const date = new Date(item.price_fetched_at);
  if (Number.isNaN(date.getTime())) return null;
  if (item.price_session === "extended") {
    return `Extended hours · ${quoteDate(item.price_fetched_at)}`;
  }
  if (item.price_session === "closed") return `Market closed · ${quoteDate(item.price_fetched_at)}`;
  if (item.price_source === "eod") return `Close · ${quoteDate(item.price_fetched_at)}`;
  return null;
}
